import { defineMessages } from 'react-intl';

export default defineMessages({
  programmed: {
    id: 'ReactFilters.messages.status.programmed', // 1
    defaultMessage: 'Programmed',
  },
  rescheduled: {
    id: 'ReactFilters.messages.status.rescheduled', // 2
    defaultMessage: 'Rescheduled',
  },
  movedOnline: {
    id: 'ReactFilters.messages.status.movedOnline', // 3
    defaultMessage: 'Moved online',
  },
  postponed: {
    id: 'ReactFilters.messages.status.postponed', // 4
    defaultMessage: 'Postponed',
  },
  full: {
    id: 'ReactFilters.messages.status.full', // 5
    defaultMessage: 'Fully booked',
  },
  cancelled: {
    id: 'ReactFilters.messages.status.cancelled', // 6
    defaultMessage: 'Cancelled',
  },
});
